import { AccommodationType } from './AccommodationType';
import MultilangText from './MultilangText';
export default class AccommodationTypeList {
    constructor(data) {
        Object.defineProperty(this, "items", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "loadItems", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ({ items = [] }) => {
                // JSON.parse output is plain objects with no prototype, so any caller of
                // `displayName` would otherwise throw. Re-attach the AccommodationType
                // prototype and rebuild MultilangText (its arrow methods don't survive JSON).
                this.items = items.map((x) => {
                    const at = new AccommodationType();
                    Object.assign(at, x, { name: new MultilangText(x.name) });
                    return at;
                });
            }
        });
        // in this part `accommodation_types` is spelled with one `m`, that comes from the API
        const accommodation_types = (data === null || data === void 0 ? void 0 : data.accomodation_types) || [];
        this.items = accommodation_types.map((room) => new AccommodationType(room));
    }
}
